import { STORE_ORIGIN } from '../config';
﻿import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import './CategoryProductPage.css';

const BASE_URL = `${STORE_ORIGIN}/admin`;

function CategoryProductPage() {
  const { mainSlug, categorySlug } = useParams();
  const [category, setCategory] = useState(null);
  const [mainCategory, setMainCategory] = useState(null);
  const [subcategoryImages, setSubcategoryImages] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Helper function to get image URL
  // Helper function to get image URL - FIXED
const getImageUrl = (imagePath, type = 'subcategories') => {
  if (!imagePath) return null;
  
  // Remove any quotes or trailing characters
  let cleanPath = imagePath.trim();
  cleanPath = cleanPath.replace(/^["']|["']$/g, ''); // Remove surrounding quotes
  cleanPath = cleanPath.replace(/&quot;/g, ''); // Remove HTML entities
  
  //console.log('Cleaned path:', cleanPath); // Debug log
  
  if (cleanPath.startsWith('http')) {
    return cleanPath;
  }
  
  // Check if path already contains 'uploads/'
  if (cleanPath.includes('uploads/')) {
    // If it's already a full relative path, just prepend BASE_URL
    return `${BASE_URL}/${cleanPath}`;
  }
  
  // If it's just a filename, construct the path
  return `${BASE_URL}/admin/uploads/${type}/${cleanPath}`;
};

  // Get fallback image based on subcategory name
  const getFallbackImage = (subcategoryName) => {
    const name = subcategoryName.toLowerCase();
    
    if (name.includes('glove') || name.includes('gloves')) {
      return `https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=600&fit=crop&text=${encodeURIComponent(subcategoryName)}`;
    } else if (name.includes('protective') || name.includes('protection') || name.includes('gear')) {
      return `https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?w=800&h=600&fit=crop&text=${encodeURIComponent(subcategoryName)}`;
    } else if (name.includes('uniform') || name.includes('gi') || name.includes('apparel')) {
      return `https://images.unsplash.com/photo-1576678927484-cc907957088c?w=800&h=600&fit=crop&text=${encodeURIComponent(subcategoryName)}`;
    } else if (name.includes('training') || name.includes('equipment')) {
      return `https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&h=600&fit=crop&text=${encodeURIComponent(subcategoryName)}`;
    } else if (name.includes('belt') || name.includes('belts')) {
      return `https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=800&h=600&fit=crop&text=${encodeURIComponent(subcategoryName)}`;
    } else if (name.includes('kickbox') || name.includes('karate') || name.includes('boxing')) {
      return `https://images.unsplash.com/photo-1542239548-3d5d09d69e9b?w=800&h=600&fit=crop&text=${encodeURIComponent(subcategoryName)}`;
    } else if (name.includes('leg') || name.includes('guard')) {
      return `https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&h=600&fit=crop&text=${encodeURIComponent(subcategoryName)}`;
    } else {
      return `https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=600&fit=crop&text=${encodeURIComponent(subcategoryName)}`;
    }
  };

  // Format category name for display
  const formatCategoryName = (name) => {
    if (!name) return '';
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch category data from api.php
        const res = await fetch(`${STORE_ORIGIN}/api/api.php`);
        const data = await res.json();

        const foundMainCategory = data.find(mc => mc.slug === mainSlug);
        if (!foundMainCategory) throw new Error("Main category not found");

        setMainCategory(foundMainCategory);

        const selectedCategory = foundMainCategory.categories.find(cat => cat.slug === categorySlug);
        if (!selectedCategory) throw new Error("Category not found");

        setCategory(selectedCategory);

        // Now fetch subcategory images from test.php
        // Now fetch subcategory images from test.php
try {
  const testRes = await fetch(`${STORE_ORIGIN}/api/test.php`);
  const testData = await testRes.json();

  const testMainCategory = testData.find(mc => mc.slug === mainSlug);
  if (testMainCategory) {
    const testCategory = testMainCategory.categories?.find(cat => cat.slug === categorySlug);
    if (testCategory && testCategory.subcategories) {
      const imageMap = {};
      testCategory.subcategories.forEach(sub => {
        if (sub.image) {
         // console.log('Raw image data for', sub.name, ':', sub.image); // Debug
          imageMap[sub.slug] = getImageUrl(sub.image, 'subcategories');
          //console.log('Generated URL:', imageMap[sub.slug]); // Debug
        }
      });
      setSubcategoryImages(imageMap);
    }
  }
} catch (testError) {
  //console.warn("Could not load subcategory images from test.php:", testError);
}

      } catch (err) {
       // console.error(err);
        setError(err.message || "Failed to fetch category");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [mainSlug, categorySlug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-6 text-center">
        <p className="text-red-600 text-xl mb-4 font-bold">{error}</p>
        <Link 
          to="/" 
          className="text-blue-600 hover:underline"
        >
          ← Back to Home
        </Link>
      </div>
    );
  }

  if (!category) {
    return (
      <div className="container mx-auto p-6 text-center">
        <p className="text-gray-700 text-xl mb-4">Category not found</p>
        <Link 
          to="/" 
          className="text-blue-600 hover:underline"
        >
          ← Back to Home
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Breadcrumb Navigation - SIMPLIFIED */}
      {/* Breadcrumb Navigation - SIMPLIFIED */}
<div className="bg-white border-b page-header">
  <div className="container mx-auto px-4 py-3">
    <nav className="flex items-center text-sm breadcrumb">
      <Link to="/" className="hover:text-red-600 transition">
        Home
      </Link>
      <span className="mx-2 breadcrumb-separator">/</span>
      {/* Non-clickable main category - just for context */}
      <span className="text-gray-500">
        {mainCategory?.name || formatCategoryName(mainSlug)}
      </span>
      <span className="mx-2 breadcrumb-separator">/</span>
      <span className="breadcrumb-current">
        {category.name}
      </span>
    </nav>
  </div>
</div>

      {/* Header */}
      <div className="container mx-auto px-4 py-8">
        <div className="mb-4">
          <Link 
            to="/" 
            className="inline-flex items-center text-sm text-red-600 hover:text-red-700 mb-2"
          >
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Home
          </Link>
        </div>
        
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
          {category.name}
        </h1>
        <p className="text-gray-600 max-w-3xl">
          Browse through our collection of {category.name.toLowerCase()} gear. Select a subcategory to view specific products.
        </p>
        
        {/* Optional: Show similar categories */}
        {mainCategory?.categories && mainCategory.categories.length > 1 && (
          <div className="mt-6">
            <p className="text-gray-700 font-medium mb-2">Explore other categories:</p>
            <div className="flex flex-wrap gap-2">
              {mainCategory.categories
                .filter(cat => cat.slug !== categorySlug)
                .slice(0, 5)
                .map(otherCategory => (
                  <Link
                    key={otherCategory.id}
                    to={`/${mainSlug}/${otherCategory.slug}`}
                    className="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-sm transition-colors"
                  >
                    {otherCategory.name}
                  </Link>
                ))}
            </div>
          </div>
        )}
      </div>

      {/* Subcategories Grid */}
      <div className="container mx-auto px-4 pb-12">
        {category.subcategories && category.subcategories.length > 0 ? (
          <>
            <div className="flex justify-between items-center mb-6">
  <div className="stats-counter">
    <span className="font-semibold">{category.subcategories.length}</span> subcategories available
  </div>
</div>

            

<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
  {category.subcategories.map((sub, index) => {
    const subcategoryImage = subcategoryImages[sub.slug] || getFallbackImage(sub.name);
    const productCount = sub.products?.length || 0;

    return (
      <Link
        key={sub.id}
        to={`/${mainSlug}/${categorySlug}/${sub.slug}`}
        className="subcategory-card group"
        style={{ animationDelay: `${index * 0.1}s` }}
      >
        {/* Background Image */}
        <div className="image-container">
          <div 
            className="image-background"
            style={{ backgroundImage: `url(${subcategoryImage})` }}
          >
            {/* Gradient Overlay */}
            <div className="gradient-overlay"></div>
            
            {/* Product Count Badge */}
            {productCount > 0 && (
              <div className="product-count-badge">
                {productCount} {productCount === 1 ? 'product' : 'products'}
              </div>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="card-content">
          <h2 className="card-title">{sub.name}</h2>
          
          {productCount > 0 ? (
            <p className="card-subtitle">
              Shop {productCount} {productCount === 1 ? 'item' : 'items'}
            </p>
          ) : (
            <p className="card-subtitle">Coming soon</p>
          )}
          
          <div className="mt-3">
            <span className="view-products-btn">
              View Products
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </span>
          </div>
        </div>

        {/* Hover Effects Overlay */}
        <div className="hover-effects-overlay"></div>
      </Link>
    );
  })}
</div>
          </>
        ) : (
          <div className="empty-state">
  <div className="empty-state-icon">
    <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
    </svg>
  </div>
  <h3 className="empty-state-title">No Subcategories Found</h3>
  <p className="empty-state-description">
    There are no subcategories available for this category at the moment.
  </p>
  <Link 
    to="/" 
    className="back-button"
  >
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
    Back to Home
  </Link>
</div>
        )}

        {/* Back to Home Link */}
        <div className="mt-12 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center text-gray-600 hover:text-red-600 transition px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CategoryProductPage;